import { bootToolPage } from '../lib/boot-tool'

bootToolPage('refresh-rate')

document.querySelector('[data-action="measure"]')?.addEventListener('click', () => {
  const avgNode = document.querySelector('[data-hz-avg]')
  const lowNode = document.querySelector('[data-hz-low]')
  const framesNode = document.querySelector('[data-hz-frames]')
  const button = document.querySelector<HTMLButtonElement>('[data-action="measure"]')
  const progress = document.querySelector<HTMLElement>('[data-measure-progress]')
  const bar = document.querySelector<HTMLElement>('[data-measure-bar]')
  if (button) button.disabled = true
  if (progress) progress.hidden = false
  if (bar) bar.style.width = '0%'

  const samples: number[] = []
  let last = performance.now()
  const startedAt = last
  const endsAt = last + 5000

  const tick = (now: number) => {
    const delta = now - last
    last = now
    if (delta > 0 && delta < 100) samples.push(1000 / delta)
    if (bar) bar.style.width = `${Math.min(100, ((now - startedAt) / 5000) * 100)}%`
    if (now < endsAt) {
      requestAnimationFrame(tick)
      return
    }

    samples.sort((a, b) => a - b)
    const avg = samples.reduce((sum, n) => sum + n, 0) / Math.max(samples.length, 1)
    const lowIndex = Math.max(0, Math.floor(samples.length * 0.01))
    const low = samples[lowIndex] ?? 0
    if (avgNode) avgNode.textContent = avg.toFixed(1)
    if (lowNode) lowNode.textContent = low.toFixed(1)
    if (framesNode) framesNode.textContent = String(samples.length)
    if (button) button.disabled = false
    window.setTimeout(() => {
      if (progress) progress.hidden = true
    }, 450)
  }

  requestAnimationFrame(tick)
})
